import { Box, useTheme } from '@mui/material';

import { formatToDateAndTime, Typography } from '@zendesk/forethought-elements';

export function DateCell({ dateString }: { dateString: string }) {
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography color={palette.colors.grey[600]} variant='font12'>
        {formatToDateAndTime(dateString)}
      </Typography>
    </Box>
  );
}
